/* eslint-disable no-console */
import React, { useMemo } from 'react';
import store from 'store';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import moment from 'moment';
import Box from 'ui-box';
import { Button } from 'antd';
import InputField from '../form-helpers/InputField';
import PhoneInputField from '../form-helpers/PhoneInputField';
import { FormInputArea } from '../form-helpers/FormField';
import LoadingSpinner from '../../common/LoadingSpinner';
import { LOCAL_STORAGE_AUTH_KEY } from '../../../config/constants';
import AuthService from '../../../services/AuthService';
import AuthGuestLoggedin from '../../../services/AuthGuestLoggedinService';
import { postSubmitAnswerAPICall } from '../../../api';
import { postAppointmentAnonymousAPICall, postAppointmentAPICall } from '../../../api/appointment';
import { successNotification, errorNotification } from '../../../utils/notification-helpers';

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
}

function SubmitResponseForm({ onSubmitBtnText, onSubmitForm }) {
  const { t } = useTranslation(['common', 'speak-doctor']);

  const FormSchema = useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string().required(t('form.error.required')),
        phone: Yup.string().required(t('form.error.required')),
        issue: Yup.string().required(t('form.error.required'))
      }),
    [t]
  );

  const initialValues = {
    name: '',
    phone: '',
    issue: ''
  };

  return (
    <div style={{ width: '100%', textAlign: 'left' }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={FormSchema}
        onSubmit={async (values) => {
          const dataForm = { ...values };
          const { responseStatus } = await postSubmitAnswerAPICall(dataForm);
          if (responseStatus === 200) {
            let guid = store.get(LOCAL_STORAGE_AUTH_KEY.GUEST_ID);
            const authCheck = new AuthGuestLoggedin()
            const dataAppointment = {
              appointment_type: "Video",
              encounter_type: "New Patient",
              tag: "Other",
              appointment_date: moment(),
              health_consern: values.issue,
              status: "Pending",
              mobile: values.phone
            }
            if (authCheck.loggedIn()) {
              const auth = new AuthService();
              const profile = auth.getUserProfile();
              guid = profile.guid;
            }
            dataAppointment.patients_ref = guid
            if (authCheck.loggedIn()) {
              const { responseOk } = await postAppointmentAPICall(dataAppointment);
              if (responseOk) {
                successNotification(t('form.success.submit'));
                onSubmitForm()
              }
            } else {
              const { responseOk } = await postAppointmentAnonymousAPICall(dataAppointment);
              if (responseOk) {
                successNotification(t('form.success.submit'));
                onSubmitForm()
              }
            }
          } else {
            errorNotification(t('form.error.submit'));
          }
        }}
      >
        {({ isSubmitting, isValid }) => {
          return (
            <Form>
              <fieldset disabled={isSubmitting}>
                <InputField
                  type="text"
                  name="name"
                  label={t('speak-doctor:submitRequest.form.name.label')}
                  placeholder={t('speak-doctor:submitRequest.form.name.placeholder')}
                />
                <PhoneInputField
                  name="phone"
                  label={t('speak-doctor:submitRequest.form.phone.label')}
                  placeholder={t('speak-doctor:submitRequest.form.phone.placeholder')}
                />
                <FormInputArea
                  name='issue'
                  style={{ width: '100%', padding: '3%' }}
                  formItemLayout={formItemLayout}
                  label={t('speak-doctor:submitRequest.form.issue.label')}
                  rows={6}
                />
                <Box paddingTop={15}>
                  <Button
                    disabled={isSubmitting || !isValid}
                    loading={isSubmitting}
                    htmlType="submit"
                    type="primary"
                    size="large"
                    block
                  >
                    {isSubmitting ? <LoadingSpinner position="full" transparent={false} /> : onSubmitBtnText}
                  </Button>
                </Box>
              </fieldset>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

SubmitResponseForm.defaultProps = {
  onSubmitBtnText: 'Submit Response',
};

const { string, func } = PropTypes;

SubmitResponseForm.propTypes = {
  onSubmitBtnText: string,
  onSubmitForm: func
};

export default SubmitResponseForm;
